import { AllWorksViews } from "."
import { WorksFields } from "../../components/work"
import { getAllWorks, getWorkData } from "../../util/airtable-works"
import { useState } from "react"
import { AllFilters } from "../../components/workIndex/worksNav"
import slugify from "slugify"
import WorkIndex from "../../components/work"
import { GetStaticPropsContext } from "next"
import { base, minifyRecords } from "../api/utils/airtable"
import { useCTX } from "../../util/context"
import { NextSeo } from "next-seo"

const Works = (props: WorksFields) => {
  const category = props.category ? props.category[0] : AllFilters.Overview
  const categorySlug = slugify(category, { replacement: "-", lower: true })
  const { workctx } = useCTX()
  const [worksNav, setWorksNav] = useState(workctx ? workctx : categorySlug)

  const worksIndexProps = { ...props, worksNav, setWorksNav }
  const pageTitle = props.title
  const featuredImageUrl = props.image_url

  // Get the width and height from the `image_preview` attachment thumbnamil field
  const featuredImage = props.image_preview[0]
  const thumb = featuredImage.thumbnails && featuredImage.thumbnails.full
  const featuredImageWidth = thumb && thumb.width
  const featuredImageHeight = thumb && thumb.height

  const canonical = `${process.env.NEXT_PUBLIC_URL}/works/${props.id}`

  return (
    <>
      {featuredImageUrl && (
        <NextSeo
          title={pageTitle}
          canonical={canonical}
          openGraph={{
            images: [
              {
                url: featuredImageUrl,
                width: featuredImageWidth,
                height: featuredImageHeight,
                alt: pageTitle,
                type: "image/jpeg",
              },
            ],
          }}
        />
      )}
      <WorkIndex {...worksIndexProps} />
    </>
  )
}

export default Works

export async function getStaticProps(context: GetStaticPropsContext) {
  const pageData = await getWorkData(context.params)

  if (!pageData) {
    return { notFound: true }
  }

  const category: any = pageData.category ? pageData.category : [AllWorksViews.Overview]

  const allworks = base("All Works")

  // Get Overview pagination data
  let overviewData = null
  if (category.includes("Overview")) {
    overviewData = await allworks
      .select({ view: AllWorksViews.Overview, fields: ["id", "title", "category", "record_id"] })
      .all()
  }

  // Remove Overview from the array of categories
  const index = category.indexOf("Overview")
  if (index > -1) {
    category.splice(index, 1)
  }

  // Get the Work category pagination data
  const paginationData = await allworks
    .select({ view: category[0], fields: ["id", "title", "category", "record_id"] })
    .all()

  return {
    props: {
      ...pageData,
      paginationData: minifyRecords(paginationData),
      overviewData: overviewData && minifyRecords(overviewData),
    },
  }
}

export const getStaticPaths = async () => {
  const allWorks = await getAllWorks(AllWorksViews.AllWorks)
  const allIndexPages = allWorks.map((page) => ({
    params: {
      id: page.params.id,
    },
  }))

  return {
    paths: allIndexPages,
    fallback: false,
  }
}
